import { handleGenerateProductLinkProps } from "@faire/retailer-visitor-shared/components/SearchProducts/utils";
import { ILeanProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/useUserStore";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageFilterKeys } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageProductResults/__internal__/useSearchPageFilterKeys";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export interface ProductUrlParameters {
  token: string | undefined;
  brandToken: string | undefined;
  impressionId: string | undefined;
  selectedProductOptionToken: string | undefined;
}

export const productUrlParametersILeanProductTileAdapter = (
  productTile: ILeanProductTile
): ProductUrlParameters => {
  return {
    token: productTile.product?.token,
    brandToken: productTile.product?.brand_token,
    impressionId: productTile.product?.impression_id,
    selectedProductOptionToken: productTile.selected_product_option_token,
  };
};

export const useProductLinkProps = (params: ProductUrlParameters) => {
  const generateProductLinkProps = useGenerateProductLinkPropsFn(params);
  return generateProductLinkProps();
};

const useGenerateProductLinkPropsFn = (params: ProductUrlParameters) => {
  const productSearchString = useSearchPageProductSearchString();
  const filterKeys = useSearchPageFilterKeys();
  const location = useLocation();
  const { user } = useUserStore(["user"]);

  return useMemo(
    () =>
      handleGenerateProductLinkProps(
        productSearchString,
        params,
        // TODO: it looks like this field isn't used, we only pass refF to the backend on the brand page
        filterKeys || [],
        location,
        user
      ),
    [filterKeys, productSearchString, params, location, user]
  );
};
